module.exports = __webpack_public_path__ + "img/thanks.53443d62.png";